import React, { ComponentType, ReactNode } from 'react'
import { AppLoading } from 'live/components/ui/Loading'
import GlobalStyles from '../styles/globalStyles'

type Props = {
    children: ReactNode
    fallback?: ReactNode
}

export const SuspenseWrapper: React.FC<Props> = ({ children, fallback }: Props) => {
    return <React.Suspense fallback={fallback ?? <AppLoading />}>{children}</React.Suspense>
}

export function withSuspenseWrapper<P>(Component: ComponentType<P>): ComponentType<P> {
    const WrappedBySuspense: React.FC<P> = props => (
        <SuspenseWrapper>
            <GlobalStyles />
            <Component {...props} />
        </SuspenseWrapper>
    )

    return WrappedBySuspense
}

export function withCustomSuspenseWrapper<P>(Component: ComponentType<P>, fallback?: ReactNode): ComponentType<P> {
    const WrappedBySuspense: React.FC<P> = props => (
        <SuspenseWrapper fallback={fallback}>
            <GlobalStyles />
            <Component {...props} />
        </SuspenseWrapper>
    )

    return WrappedBySuspense
}
